import * as tslib_1 from "tslib";
import { Component, Vue, Ref } from "vue-property-decorator";
import { scrollTop } from "@/utils/scroll-to";
import draggable from 'vuedraggable';
import { getCourseContent, searchMediaList, getProductInfo, uploadCourseCover, saveChapter, deleteChapter, updateMediaSort, updateChapterMediaSort, deleteMediaContent, addMediaContent, getTermInfo, saveTermInfo, getExamPageCourse, updateTaskTitle, getTermShopProductList, getShopComposeProduct, saveTermShopProduct } from "@/api/course";
import { UserModule } from "@/store/modules/user";
import WangEditor from "@/components/WangEditor/index.vue";
import { Debounce } from "@/decorators";
import eventEmitter from '@/utils/eventEmitter';
import { checkSession } from '@/api/commom';
const tabsMap = ["", "profile", "content"];
const mediaTypeMap = ["", "音频", "视频", "图文", "考试"];
const mediaStatusMap = ["未上架", "已上架"];
// 根据后端要求 本地拼接商品详情页路由 并传给后端
const courseDetailRouter = {
    1: '/details',
    3: '/graphic/details',
    4: '/activity/details',
    9: '/team/details',
    10: '/combined/details',
};
let timer = null;
let CourseEdit = class CourseEdit extends Vue {
    constructor() {
        super(...arguments);
        this.currentTab = "profile";
        this.courseData = {
            id: "",
            name: "",
            type: 1,
            cover: "",
            description: "",
            totalCount: 0,
            updatedCount: 0,
            details: "",
            productList: [],
            isChapterEnabled: 0,
            dateTime: [],
            unlockMode: 0,
            unlockCondition: {
                unlockInterval: '',
                unlockTimeUnit: 'day',
                unlockUnit: 'node',
                unlockTime: ''
            }
        };
        this.campId = '';
        this.isCoverLoading = false; // 课程封面加载状态
        this.isProductAdd = false; // 精选推荐添加状态
        this.productIdToAdd = ""; // 推荐课程对应的商品ID
        // v5.7.10 改用chapterList
        // private courseContentList: IMedia[] = []; // 当前课程的课程内容 
        this.isCourseContentLoading = false; // 课程内容加载状态
        // 课程内容选择器
        this.mediaViewer = {
            isVisible: false,
            isLoading: false,
            keyword: "",
            _keyword: "",
            mediaList: [],
            selectedList: [],
        };
        // 课程内容列表分页器
        this.mediaPaginator = {
            pageNo: 1,
            pageSize: 15,
            total: 0,
        };
        this.productIdState = {
            isError: false,
            message: ''
        };
        this.seminarIdState = {
            isError: false,
            message: ''
        };
        this.chapterList = []; // 当前课程的章节列表
        this.chapterEditor = {
            isEdit: false,
            chapter: {
                id: '',
                name: ''
            }
        };
        this.chooseType = '1';
        this.product = {
            list: [
                {
                    gradeCode: '21',
                    shopProductId: '',
                    shopProductName: '',
                },
                {
                    gradeCode: '22',
                    shopProductId: '',
                    shopProductName: '',
                },
                {
                    gradeCode: '23',
                    shopProductId: '',
                    shopProductName: '',
                },
                {
                    gradeCode: '31',
                    shopProductId: '',
                    shopProductName: '',
                },
                {
                    gradeCode: '32',
                    shopProductId: '',
                    shopProductName: '',
                },
                {
                    gradeCode: '33',
                    shopProductId: '',
                    shopProductName: '',
                }
            ]
        };
    }
    created() {
        const query = this.$route.query;
        // 传入ID则判定为编辑 未传入则为新增
        if (query.campId) {
            this.campId = query.campId;
        }
        if (query.id) {
            this.courseData.id = query.id;
            if (query.step) {
                this.currentTab = tabsMap[Number(query.step)];
            }
            this.getCourseData();
            this.getContentList();
            this.loadProductList();
        }
        const t = 1 * 60 * 1000;
        timer = setInterval(() => {
            this.checkHeartbeat();
        }, t);
        eventEmitter.on('routerRapture', () => {
            return Promise.reject();
        });
    }
    beforeDestroy() {
        clearInterval(timer);
    }
    async checkHeartbeat() {
        await checkSession();
    }
    handleTabChange(tab) {
        // if (this.currentTab === "profile") {
        //   this.getCourseData();
        // } else if (this.currentTab === "content") {
        //   this.getContentList();
        // }
        // this.$confirm("离开将不保存本页修改", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "warning",
        // })
        //   .then(() => {
        //     // 你可以在这儿做些操作
        //   })
        //   .catch((err) => {});
    }
    // 获取课程数据
    async getCourseData() {
        const res = await getTermInfo(this.courseData.id);
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return;
        this.courseData = {
            id: data.id,
            name: data.name,
            cover: data.picUrl,
            type: data.type,
            description: data.description,
            totalCount: data.totalPeriod,
            updatedCount: data.updatePeriod,
            details: data.content,
            productList: data.productList.map((product) => {
                return {
                    id: String(product.id),
                    image: product.image,
                    title: product.name,
                };
            }),
            isChapterEnabled: data.isOpenChapter || 0,
            dateTime: [data.startTime || '', data.endTime || ''],
            unlockMode: data.unlockMode || 0,
            unlockCondition: data.unlockCondition || {
                unlockInterval: '',
                unlockTimeUnit: 'day',
                unlockUnit: 'node',
                unlockTime: ''
            }
        };
        if (data.content) {
            this.wangEditor.setContent(data.content);
        }
    }
    async onSaveMediaName(props) {
        if (props.name === '') {
            this.$message.error("任务名称不可为空");
            return false;
        }
        let data = {
            courseDataId: props.id,
            taskTitle: props.name
        };
        const res = await updateTaskTitle(data);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.$message({
            type: 'success',
            message: '保存成功'
        });
        props.isEdit = false;
    }
    // 选择课程封面
    handleCoverSelect(file) {
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            this.$message.error("封面图片大小不能超过 5MB!");
            return false;
        }
        const isJPG = file.type === "image/jpg" || file.type === "image/jpeg";
        const isPNG = file.type === "image/png";
        if (!(isJPG || isPNG)) {
            this.$message.error("封面图片只能是JPG/PNG格式!");
            return false;
        }
        return true;
    }
    // 上传课程封面
    async handleCoverUpload(data) {
        this.isCoverLoading = true;
        const file = data.file;
        try {
            const res = await uploadCourseCover(file, {
                token: UserModule.token,
                ssoId: UserModule.ssoId,
            });
            // 防止奇奇怪怪的人卡bug, 重置状态后再取消禁用上传
            this.$nextTick(() => {
                this.isCoverLoading = false;
            });
            if (res.data.status !== 200) {
                // 上传器公用 随手清理垃圾
                return this._coverUploader.clearFiles();
            }
            this.courseData.cover = res.data.data;
        }
        catch {
            this.isCoverLoading = false;
        }
    }
    // 添加精选推荐
    async hanldeProductAdd() {
        const id = this.productIdToAdd;
        const pList = this.courseData.productList;
        if (id == "") {
            return this.$message.error("请输入推荐课程的商品ID");
        }
        if (pList.length >= 5) {
            return this.$message.error("最多只能添加5个推荐课程");
        }
        // 校验列表中是否有重复的
        if (pList.some((product) => product.id == id)) {
            return this.$message.error("列表中已有该课程");
        }
        // 获取推荐课程的信息
        const res = await getProductInfo(id);
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return this.$message.error("该ID没有对应的商品");
        this.courseData.productList.push({
            id: data.id,
            image: data.image,
            title: data.name,
        });
        this.productIdToAdd = "";
        this.isProductAdd = false;
    }
    // 删除精选推荐
    handleProductDelete(idx) {
        this.courseData.productList.splice(idx, 1);
    }
    // 保存课程数据
    async saveCourseData() {
        const course = this.courseData;
        if (course.cover === "") {
            return this.$message.error("请上传封面图");
        }
        if (course.name === "") {
            return this.$message.error("营期名称不能为空");
        }
        if (course.description === "") {
            return this.$message.error("营期简介不能为空");
        }
        if (course.details === "") {
            return this.$message.error("营期详情不能为空");
        }
        if (course.totalCount <= 0) {
            return this.$message.error("营期期数输入有误,请输入大于0的正整数！");
        }
        if (!this.courseData.dateTime || this.courseData.dateTime.length == 0) {
            return this.$message.error("开课时间不可为空");
        }
        let [startTime = '', endTime = ''] = this.courseData.dateTime || [];
        const data = {
            campId: this.campId,
            id: course.id,
            name: course.name,
            picUrl: course.cover,
            description: course.description,
            totalPeriod: String(course.totalCount),
            content: course.details,
            productIds: course.productList
                .map(p => p.id)
                .join(","),
            unlockMode: course.unlockMode,
            unlockCondition: course.unlockCondition,
            startTime,
            endTime,
        };
        console.log(data);
        const res = await saveTermInfo(data);
        if (res.data.status === 200) {
            this.$message.success("保存成功");
            const id = String(res.data.data);
            // 保存成功后自动切换tab
            if (id) {
                this.courseData.id = id;
                this.courseData.isChapterEnabled = 1;
                this.currentTab = "content";
                this.getContentList();
            }
        }
    }
    // 获取课程内容
    async getContentList() {
        this.isCourseContentLoading = true;
        const res = await getCourseContent(this.courseData.id);
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return;
        // [FEATURE] 5.7.10
        this.chapterList = data.map((chapter) => ({
            id: chapter.id,
            name: chapter.name,
            mediaList: chapter.contentList && chapter.contentList.map((media) => ({
                id: media.id,
                name: media.title,
                type: mediaTypeMap[media.type] || "-",
                typeVal: media.type,
                size: media.mediaSize || "-",
                status: mediaStatusMap[media.contentStatus] || "-",
                addTime: media.delayedTime,
                mediaId: media.mediaId,
                examId: media.examId,
                unlockTime: media.unlockTime || '',
                isEdit: false,
            })) || []
        }));
        this.isCourseContentLoading = false;
    }
    // 删除课程内容
    async handleContentDelete(idx, pidx) {
        const _media = this.chapterList[pidx].mediaList[idx];
        try {
            await this.$confirm(`是否确认删除 “${_media.name}”`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            });
        }
        catch (error) {
            return;
        }
        try {
            const query = {
                courseDataIds: _media.id,
            };
            const res = await deleteMediaContent(query);
            if (res.data.status !== 200)
                return;
            this.chapterList[pidx].mediaList.splice(idx, 1);
            this.getCourseData();
            this.getContentList();
            this.chapterEditor.isEdit = false;
            this.$message.success("删除成功");
        }
        catch (error) { }
    }
    // 排序课程内容
    async handleContentSort(pidx) {
        // const query: Record<string, any> = {
        //   chapterId: this.chapterList[pidx].id,
        //   mediaIds: this.chapterList[pidx].mediaList.map((media) => media.id).join(","),
        // };
        console.log(this.chapterList);
        const mediaIds = this.chapterList[pidx].mediaList.map((media) => media.id).join(",");
        try {
            const res = this.courseData.isChapterEnabled === 1 ? await updateChapterMediaSort({
                chapterId: this.chapterList[pidx].id,
                courseDataIds: mediaIds,
            }) : await updateMediaSort({
                courseId: this.courseData.id,
                courseDataIds: mediaIds,
            });
            if (res.data.status !== 200)
                throw new Error("排序失败");
            this.getContentList();
        }
        catch (error) {
            // 复原排序
            this.getContentList();
            // this.$message.error('排序保存失败');
        }
    }
    async getExamList() {
        const res = await getExamPageCourse({
            name: this.mediaViewer._keyword,
            pageNo: this.mediaPaginator.pageNo,
            courseId: this.courseData.id,
            pageSize: this.mediaPaginator.pageSize
        });
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return;
        this.mediaViewer.mediaList = data.list.map((media) => {
            return {
                id: String(media.id),
                name: media.name,
                image: media.imgUrl,
            };
        });
        this.mediaViewer.isLoading = false;
        this.mediaPaginator.total = Number(data.total);
    }
    handleClickType(tabs) {
        this.chooseType = tabs.name;
        this.mediaPaginator.pageNo = 1;
        if (tabs.name == 4) {
            this.getExamList();
        }
        else {
            this.getMediaList();
        }
    }
    // 新增课程内容弹窗
    showMediaViewer(chapterId) {
        if (this.chapterEditor.isEdit) {
            this.$message.error("请先完成当前编辑");
            return;
        }
        this.mediaPaginator = {
            pageNo: 1,
            pageSize: 15,
            total: 0,
        };
        this.mediaViewer = {
            isVisible: true,
            isLoading: true,
            keyword: "",
            _keyword: "",
            mediaList: [],
            selectedList: [],
            chapterId,
        };
        this.getMediaList();
    }
    // 获取课程内容列表（弹窗）
    async getMediaList() {
        const res = await searchMediaList({
            searchName: this.mediaViewer._keyword,
            pageNo: this.mediaPaginator.pageNo,
            pageSize: this.mediaPaginator.pageSize,
            type: this.chooseType,
            courseId: this.courseData.id,
        });
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return;
        this.mediaViewer.mediaList = data.list.map((media) => {
            return {
                id: String(media.id),
                name: media.title,
                image: media.fileUrl,
            };
        });
        this.mediaViewer.isLoading = false;
        this.mediaPaginator.total = Number(data.total);
    }
    // 搜索课程内容列表（弹窗）
    handleMediaFilter() {
        this.mediaViewer._keyword = this.mediaViewer.keyword;
        this.mediaPaginator.pageNo = 1;
        if (this.chooseType === '4') {
            this.getExamList();
        }
        else {
            this.getMediaList();
        }
    }
    // 课程内容列表换页（弹窗）
    async handleMediaPageChange(pageNo) {
        this.mediaPaginator.pageNo = pageNo;
        // 获取弹窗中表格dom
        const el = document.getElementById("audio-table").getElementsByClassName("el-table__body-wrapper")[0];
        // 表格滚动置顶后再刷新数据
        scrollTop(el, 0, 233, this.chooseType === '4' ? this.getExamList : this.getMediaList);
    }
    // 选中课程内容（弹窗）
    handleMediaSelect(selection) {
        this.mediaViewer.selectedList = selection;
    }
    // 新增课程内容
    async handleContentAdd() {
        const query = {
            courseId: this.courseData.id,
            courseDataType: this.chooseType,
            chapterId: this.mediaViewer.chapterId,
        };
        if (this.chooseType === '4') {
            query.examIds = this.mediaViewer.selectedList
                .map((media) => media.id)
                .join(",");
        }
        else {
            query.mediaIds = this.mediaViewer.selectedList
                .map((media) => media.id)
                .join(",");
        }
        try {
            const res = await addMediaContent(query);
            if (res.data.status !== 200)
                return;
            this.$message.success("添加成功");
            this.handleContentCancel();
            this.getContentList();
            this.getCourseData();
        }
        catch (error) { }
    }
    handleContentCancel() {
        console.log(11);
        this.mediaViewer.isVisible = false;
        this.chooseType = '1';
    }
    // 关闭章节名编辑
    closeChapterEditor() {
        this.chapterEditor = {
            isEdit: false,
            chapter: {
                id: "",
                name: "",
            },
        };
    }
    // 新增章节
    handleChapterAdd() {
        if (this.chapterEditor.isEdit) {
            this.$message.error("请先完成当前编辑");
            return;
        }
        this.chapterList.push({
            id: '-1',
            name: '',
            mediaList: [],
        });
        this.handleChapterEdit(this.chapterList.length - 1);
    }
    // 编辑章节
    handleChapterEdit(idx) {
        const _chapter = this.chapterList[idx];
        this.chapterEditor = {
            isEdit: true,
            chapter: {
                id: _chapter.id,
                name: _chapter.name,
            },
        };
    }
    // 确认章节修改
    async handleChapterSave(idx) {
        const _chapter = this.chapterEditor.chapter;
        if (_chapter.name.trim() === "") {
            this.$message.error("请输入章节名称");
            return;
        }
        if (_chapter.name === this.chapterList[idx].name) {
            this.chapterEditor.isEdit = false;
            return;
        }
        if (this.chapterList.some(chapter => chapter.name === _chapter.name)) {
            this.$message.error("章节名称重复");
            return;
        }
        try {
            const { data } = await saveChapter({
                courseId: this.courseData.id,
                chapterId: _chapter.id === '-1' ? undefined : _chapter.id,
                chapterName: _chapter.name,
            });
            if (data.status !== 200)
                return;
            this.chapterList[idx].name = _chapter.name;
            this.chapterList[idx].id = data.data;
            this.closeChapterEditor();
        }
        catch (error) { }
    }
    handleChapterCancel(idx) {
        console.log(this.chapterList[idx]);
        if (this.chapterList[idx].id != '-1') {
            this.chapterEditor.isEdit = false;
        }
        else {
            this.chapterEditor.isEdit = false;
            this.chapterList.splice(idx, 1);
        }
    }
    // 删除章节
    async handleChapterDelete(idx) {
        if (this.chapterEditor.isEdit) {
            if (this.chapterEditor.chapter.id !== this.chapterList[idx].id) {
                this.$message.error("请先完成当前编辑");
                return;
            }
            this.chapterList.splice(idx, 1);
            this.closeChapterEditor();
        }
        else {
            try {
                await this.$confirm(`是否删除章节 “${this.chapterList[idx].name}”`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                });
            }
            catch (error) {
                return;
            }
            try {
                const { data } = await deleteChapter(this.chapterList[idx].id);
                if (data.status !== 200)
                    return;
                this.chapterList.splice(idx, 1);
            }
            catch (error) { }
        }
    }
    onJumpPage(props) {
        console.log(props);
        if (props.typeVal == 1) {
            this.$router.push({
                path: '/data-manager/audio/edit',
                query: {
                    id: props.mediaId
                }
            });
        }
        else if (props.typeVal == 2) {
            this.$router.push({
                path: '/data-manager/video/edit',
                query: {
                    id: props.mediaId
                }
            });
        }
        else if (props.typeVal == 3) {
            this.$router.push({
                path: '/data-manager/graphic/edit',
                query: {
                    id: props.mediaId
                }
            });
        }
        else if (props.typeVal == 4) {
            // 跳转考试
            this.$router.push({
                name: 'ExamEdit',
                query: {
                    type: 'edit',
                    exam_id: props.examId
                }
            });
        }
    }
    async loadProductList() {
        try {
            const res = await getTermShopProductList(this.courseData.id);
            if (res.data.status !== 200)
                return;
            const list = [
                {
                    gradeCode: '21',
                    shopProductId: '',
                    shopProductName: '',
                },
                {
                    gradeCode: '22',
                    shopProductId: '',
                    shopProductName: '',
                },
                {
                    gradeCode: '23',
                    shopProductId: '',
                    shopProductName: '',
                },
                {
                    gradeCode: '31',
                    shopProductId: '',
                    shopProductName: '',
                },
                {
                    gradeCode: '32',
                    shopProductId: '',
                    shopProductName: '',
                },
                {
                    gradeCode: '33',
                    shopProductId: '',
                    shopProductName: '',
                }
            ];
            res.data.data && res.data.data.forEach((item) => {
                const _item = list.find(grade => grade.gradeCode == item.gradeCode);
                if (_item) {
                    _item.shopProductId = item.shopProductId;
                    _item.shopProductName = item.shopProductName;
                }
            });
            this.product.list = list;
        }
        catch (error) {
        }
    }
    async handleProductIdValidate(index, value, cb) {
        if (value.trim() === '') {
            this.product.list[index].shopProductName = '';
            cb();
            return;
        }
        if (!/^\d+$/.test(value)) {
            cb('商品不存在');
            return;
        }
        try {
            const res = await getShopComposeProduct(value);
            if (res.data.status !== 200)
                return;
            if (res.data.data.name) {
                this.product.list[index].shopProductName = res.data.data.name;
                cb();
            }
            else {
                this.product.list[index].shopProductName = '';
                cb(res.data.data.message);
            }
        }
        catch (error) {
            this.product.list[index].shopProductName = '';
        }
        cb();
    }
    async handleProductListSave() {
        try {
            await this.productFormRef.validate();
        }
        catch (error) {
            return;
        }
        const data = {
            courseId: this.courseData.id,
            gradeShopProductList: this.product.list.filter(item => item.shopProductId).map(item => ({
                gradeCode: item.gradeCode,
                shopProductId: item.shopProductId
            }))
        };
        try {
            const res = await saveTermShopProduct(data);
            if (res.data.status !== 200)
                return;
            this.$message.success("保存成功");
        }
        catch (error) {
        }
    }
};
tslib_1.__decorate([
    Ref()
], CourseEdit.prototype, "_coverUploader", void 0);
tslib_1.__decorate([
    Ref()
], CourseEdit.prototype, "_audioTable", void 0);
tslib_1.__decorate([
    Ref()
], CourseEdit.prototype, "wangEditor", void 0);
tslib_1.__decorate([
    Ref()
], CourseEdit.prototype, "productFormRef", void 0);
tslib_1.__decorate([
    Debounce(300)
], CourseEdit.prototype, "handleContentSort", null);
CourseEdit = tslib_1.__decorate([
    Component({
        name: "CourseEdit",
        components: {
            WangEditor,
            draggable
        },
        filters: {
            formatType: (type) => {
                if (type == 1)
                    return '音频';
                if (type == 2)
                    return '视频';
                if (type == 3)
                    return '图文';
                if (type == 4)
                    return '考试';
            },
            formatGradeCode: (code) => {
                return {
                    '21': '初一',
                    '22': '初二',
                    '23': '初三',
                    '31': '高一',
                    '32': '高二',
                    '33': '高三',
                }[code];
            }
        }
    })
], CourseEdit);
export default CourseEdit;
